import React from "react";
import { Helmet } from "react-helmet";

export default function NotFoundCustom() {
  return (
    <div id="notfound">
      <Helmet>
        <title>404 Page Not Found</title>
      </Helmet>
      <div className="notfound">
        <div className="notfound-404">
          <h1>404</h1>
        </div>
        <h2>event ended!</h2>
        <p>The most recent Purple test rest event has now ended.</p>
      </div>
    </div>
  );
}
